<template>
  <div class="faq-item">
    <div
      class="faq-item-title"
      role="button"
      tabindex="0"
      :aria-expanded="String(isVisible)"
      @click="visible = !visible"
      @keydown.enter.space.prevent="visible = !visible"
    >
      <h3 v-if="faq.question">
        <div class="category-question-icon">
          <question-mark-icon />
        </div>
        {{ faq.question }}
      </h3>
      <b-icon v-if="collapsable" class="collapsable-icon" :icon="visible ? 'chevron-up' : 'chevron-down'" aria-hidden="true" />
    </div>
    <div
      v-if="faq.answer"
      v-show="isVisible"
      class="faq-answer no-js-show"
      v-html="generate(faq.answer)"
    />
  </div>
</template>

<script>
import bbcodeHTML from 'marketplace-front-core/config/bbcodeHTML'
import QuestionMarkIcon from '~/assets/images/homepage/question-mark-italic-square.svg?inline'
export default {
  name: 'ProductFaq',
  components: { QuestionMarkIcon },
  props: {
    faq: {
      type: Object,
      default: null
    },
    collapsable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: true
    }
  },
  computed: {
    isVisible () {
      if (this.collapsable) {
        if (this.visible) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
  created () {
    this.visible = !this.collapsable
  },
  methods: {
    generate (content) {
      return bbcodeHTML(content)
    }
  }
}
</script>

<style lang="scss" scoped>
.faq-item-title {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    cursor: pointer;
    .collapsable-icon {
      color: #666666;
    }
  }
}
.collapsable-icon {
  margin-top: 3px;
  color: #c4c4c4;
}
</style>
